import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=12f58fe5"
import script from "./Provider.vue?vue&type=script&lang=js"
export * from "./Provider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@osgfe/builder-plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports